export enum StatusCode {
  bad_request = 400,
  not_found = 404,
  payment_required = 402,
  ok = 200
}
